import { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { MyOrder, OrderLog } from 'ts/shared/interfaces/MOResponse';
import Button from 'components/ui/Button/Button';
import useModalClass from 'hooks/useModalClass';
import { getStatus } from 'constants/mo';
import ScreenshotSupport from '../../ScreenshotSupport';
import MaximizeModal from '../../MaximizeModal';
import MoMoreDetails from '../MoMoreDetails';
import useDraggableModal from 'hooks/useDraggableModal';

interface MoMoreDetailsModalProps {
  openModal: boolean;
  setOpenModal: (open: boolean) => void;
  myOrder: MyOrder;
  onUpdateMyOrder: (myOrder: MyOrder) => void;
  activeInitialTab?: number;
}

const MoMoreDetailsModal: FC<MoMoreDetailsModalProps> = ({
  openModal,
  setOpenModal,
  myOrder,
  onUpdateMyOrder,
  ...props
}) => {
  const { t } = useTranslation();
  const modalOverlayRef = useRef<HTMLDivElement>(null);
  const classList = useModalClass(openModal);
  const { modalRef, modalStyle, dragHandleProps, isDragging } = useDraggableModal(true);

  const handleLoadLogs = (logs: OrderLog[]) => {
    // No-op for modal context
  };

  const handleUpdateMyOrder = (updatedOrder: MyOrder) => {
    onUpdateMyOrder(updatedOrder);
  };

  if (!openModal) return null;

  return (
    <div
      className="modal-overlay modal-overlay-top modal-maximizable" style={{ direction: 'ltr' }}
      ref={modalOverlayRef}
      onClick={(e) => e.target === e.currentTarget && setOpenModal(false)}
    >
      <div ref={modalRef} className={classList} style={{ ...modalStyle, width: '95%', maxWidth: 1400 }}>
        <div
          className={'modal-title  draggable-modal-handle' + (isDragging ? ' dragging' : '')}
          {...dragHandleProps}
        >
          <div>
            <span className="title">
              Order: {myOrder.fullSegment.orderId}{' '}
              Segment: {myOrder.fullSegment.orderSegId}{' '}
              <span className={`mo-status ${getStatus(myOrder.fullSegment.roomsStatusCode)}`}>
                {myOrder.fullSegment.roomsStatusCode}
              </span>
            </span>
          </div>
          <div data-no-drag="true">
            <ScreenshotSupport />
            <MaximizeModal modalOverlayRef={modalOverlayRef} />
            <FontAwesomeIcon icon={faTimes} onClick={() => setOpenModal(false)} />
          </div>
        </div>
        <div className="modal-content">
          <MoMoreDetails
            activeOrder={myOrder}
            onUpdateMyOrder={handleUpdateMyOrder}
            onLoadLogs={handleLoadLogs}
            activeInitialTab={props.activeInitialTab}
          />
        </div>
        <div className="modal-footer">
          <Button
            className="btn btn-default"
            title={t('close')}
            onClick={() => setOpenModal(false)}
          />
        </div>
      </div>
    </div>
  );
};

export default MoMoreDetailsModal;

